var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "10 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_185_354)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 66,
    height: 66,
    rx: 10,
    fill: "#FF0D37"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0934 23.4294C49.9505 22.9801 49.5624 22.652 49.0949 22.586L46.3299 22.1931L45.0984 19.622C44.68 18.7927 43.32 18.7927 42.9019 19.622L41.6701 22.1931L38.9051 22.586C38.4376 22.652 38.0495 22.9801 37.9066 23.4294C37.7624 23.8789 37.8884 24.3705 38.2296 24.696L40.2125 26.5824L39.7449 29.2404C39.6645 29.7006 39.8507 30.1668 40.2269 30.4434C40.6085 30.7253 41.111 30.7577 41.5198 30.5478L44 29.2741L46.4814 30.5478C46.8961 30.7628 47.3982 30.7199 47.7731 30.4434C48.1493 30.1659 48.3355 29.6996 48.255 29.2404L47.7875 26.5824L49.7704 24.696C50.1116 24.3705 50.2376 23.8789 50.0934 23.4294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.941 28.3513C64.7981 27.902 64.4101 27.5739 63.9426 27.5079L61.0955 27.115L59.8638 24.6791C59.4456 23.8501 58.0853 23.8501 57.6672 24.6791L56.4357 27.115L53.6707 27.5079C53.2032 27.5739 52.8152 27.902 52.6722 28.3513C52.528 28.8008 52.654 29.2924 52.9952 29.618L54.9781 31.5044L54.5106 34.1624C54.4301 34.6225 54.6163 35.0887 54.9925 35.3653C55.3741 35.6473 55.8763 35.6796 56.2855 35.4697L58.7656 34.196L61.2471 35.4697C61.6617 35.686 62.1613 35.6428 62.5387 35.3653C62.9149 35.0878 63.1011 34.6215 63.0207 34.1624L62.5532 31.5044L64.618 29.618C64.9593 29.2924 65.0852 28.8008 64.941 28.3513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3278 28.3513C35.1848 27.902 34.7968 27.5739 34.3293 27.5079L31.5643 27.115L30.3328 24.6791C29.9143 23.8501 28.5544 23.8501 28.1362 24.6791L26.9045 27.115L24.0574 27.5079C23.5899 27.5739 23.2019 27.902 23.059 28.3513C22.9148 28.8008 23.0407 29.2924 23.382 29.618L25.4468 31.5044L24.9793 34.1624C24.8989 34.6225 25.0851 35.0887 25.4613 35.3653C25.8429 35.6473 26.3453 35.6796 26.7542 35.4697L29.2344 34.196L31.7158 35.4697C32.1327 35.686 32.63 35.6428 33.0075 35.3653C33.3837 35.0878 33.5699 34.6215 33.4894 34.1624L33.0219 31.5044L35.0048 29.618C35.346 29.2924 35.472 28.8008 35.3278 28.3513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1523 40C50.1523 43.3979 47.3979 46.1523 44 46.1523C40.6021 46.1523 37.8477 43.3979 37.8477 40C37.8477 36.6021 40.6021 33.8477 44 33.8477C47.3979 33.8477 50.1523 36.6021 50.1523 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9258 44.9219C32.9258 46.9605 31.273 48.6133 29.2344 48.6133C27.1958 48.6133 25.543 46.9605 25.543 44.9219C25.543 42.8829 27.1958 41.2305 29.2344 41.2305C31.273 41.2305 32.9258 42.8829 32.9258 44.9219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.457 44.9219C62.457 46.9605 60.8042 48.6133 58.7656 48.6133C56.727 48.6133 55.0742 46.9605 55.0742 44.9219C55.0742 42.8829 56.727 41.2305 58.7656 41.2305C60.8042 41.2305 62.457 42.8829 62.457 44.9219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3867 61H52.6133V57.2266C52.6133 52.4694 48.7569 48.6133 44 48.6133C39.2431 48.6133 35.3867 52.4694 35.3867 57.2266V61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9189 51.1806C57.6672 50.7663 55.6119 51.5959 54.251 53.0754C54.773 54.3597 55.0742 55.7571 55.0742 57.2266V61H63.7695C64.4492 61 65 60.4492 65 59.7696V57.4874C65 54.4808 62.8755 51.7244 59.9189 51.1806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2305 61H32.9258V57.2266C32.9258 55.7571 33.227 54.3597 33.749 53.0754C32.3881 51.5959 30.3328 50.7663 28.0811 51.1806C25.1245 51.7244 23 54.4808 23 57.4874V59.7696C23 60.4492 23.5508 61 24.2305 61Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_185_354",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_185_354"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_185_354"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_185_354",
    result: "effect2_dropShadow_185_354"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_185_354",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(23 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.a8f899f13bb697703d434529d685e05a.svg";
export { ForwardRef as ReactComponent };